import { v } from "convex/values";
import { literalValues } from "@shared/validation/literal-values";

const contactCompanyTypes = [
  "customer",
  "vendor",
  "partner",
  "freight_carrier",
  "prospect",
] as const;

export const contactCompanyTypeValidator = v.union(
  ...contactCompanyTypes.map((companyType) => v.literal(companyType)),
);

export type ContactCompanyType = (typeof contactCompanyTypes)[number];

export const CONTACT_COMPANY_TYPE = {
  CUSTOMER: "customer",
  VENDOR: "vendor",
  PARTNER: "partner",
  FREIGHT_CARRIER: "freight_carrier",
  PROSPECT: "prospect",
} as const satisfies Record<string, ContactCompanyType>;

export const CONTACT_COMPANY_TYPES = literalValues(CONTACT_COMPANY_TYPE);

const contactCompanyStatuses = ["active", "inactive"] as const;

export const contactCompanyStatusValidator = v.union(
  ...contactCompanyStatuses.map((status) => v.literal(status)),
);

export type ContactCompanyStatus = (typeof contactCompanyStatuses)[number];

export const CONTACT_COMPANY_STATUS = {
  ACTIVE: "active",
  INACTIVE: "inactive",
} as const satisfies Record<string, ContactCompanyStatus>;

const contactRoles = [
  "owner",
  "primary",
  "accounting",
  "shipping",
  "warehouse",
  "sales",
  "operations",
  "executive",
  "other",
] as const;

export const contactRoleValidator = v.union(
  ...contactRoles.map((role) => v.literal(role)),
);

export const contactRolesValidator = v.array(contactRoleValidator);

export type ContactRole = (typeof contactRoles)[number];

export const CONTACT_ROLE = {
  OWNER: "owner",
  PRIMARY: "primary",
  ACCOUNTING: "accounting",
  SHIPPING: "shipping",
  WAREHOUSE: "warehouse",
  SALES: "sales",
  OPERATIONS: "operations",
  EXECUTIVE: "executive",
  OTHER: "other",
} as const satisfies Record<string, ContactRole>;

export const CONTACT_ROLES = literalValues(CONTACT_ROLE);

export const CONTACT_DOCUMENT = {
  QUOTE: "quote",
  ORDER_UPDATE: "order_update",
  DELIVERY_NOTICE: "delivery_notice",
  INVOICE: "invoice",
  PURCHASE_ORDER: "purchase_order",
  BILL_OF_LADING: "bill_of_lading",
} as const;

export type ContactDocument = (typeof CONTACT_DOCUMENT)[keyof typeof CONTACT_DOCUMENT];

export const CONTACT_DOCUMENTS = literalValues(CONTACT_DOCUMENT);

export const contactDocumentValidator = v.union(
  ...CONTACT_DOCUMENTS.map((document) => v.literal(document)),
);

export const contactDocumentsValidator = v.array(contactDocumentValidator);

export const CONTACT_DEAL_ROLE = {
  QUOTE: "quote",
  MAIN: "main",
  ACCOUNTING: "accounting",
  FULFILLMENT: "fulfillment",
} as const;

export type ContactDealRole = (typeof CONTACT_DEAL_ROLE)[keyof typeof CONTACT_DEAL_ROLE];

export const contactDealRoleValidator = v.union(
  ...literalValues(CONTACT_DEAL_ROLE).map((role) => v.literal(role)),
);
